import { render } from "./BookingsCalendar.vue?vue&type=template&id=dadd19a8&scoped=true"
import script from "./BookingsCalendar.vue?vue&type=script&lang=js"
export * from "./BookingsCalendar.vue?vue&type=script&lang=js"

import "./BookingsCalendar.vue?vue&type=style&index=0&id=dadd19a8&lang=scss&scoped=true"

import exportComponent from "C:\\laragon\\www\\runpixie_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dadd19a8"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QSpinner,QBanner,QCard,QCheckbox,QIcon});
